import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR, { useSWRConfig } from 'swr';
import appContext from '../../../context/app/appContext';
import { sleep } from '../../../web3/utils';

const useUserStakedSpool = () => {
    const { account } = useWeb3React();

    const { interfaceSDK } = useContext(appContext);

    const { mutate: globalMutate } = useSWRConfig();

    const { data, error, mutate } = useSWR(
        interfaceSDK && account ? ['userStakedSpool', account] : null,
        (_, userAddress) => interfaceSDK!.get.getStakedSpool(userAddress!)
    );

    const update = async (previousValue?: string) => {
        if (!previousValue) {
            return mutate(undefined, true);
        }

        let retries = 0;

        do {
            const currentValue = await mutate(undefined, true);

            if (currentValue !== previousValue) {
                break;
            }

            retries++;
            await sleep(3000);
        } while (retries < 5);

        globalMutate('totalStakedSpool');
    };

    return {
        userStakedSpool: data,
        isLoading: !error && !data,
        error,
        updateUserStakedSpool: update,
    };
};

export default useUserStakedSpool;
